/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateExtractionRequestDto } from '../../models/update-extraction-request-dto';
import { UpdateExtractionResponseDto } from '../../models/update-extraction-response-dto';

export interface ApiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Params {
      body?: UpdateExtractionRequestDto
}

export function apiIdpSubmissionsDirectSubmissionExtractionUpdatePost(http: HttpClient, rootUrl: string, params?: ApiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateExtractionResponseDto>> {
  const rb = new RequestBuilder(rootUrl, apiIdpSubmissionsDirectSubmissionExtractionUpdatePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateExtractionResponseDto>;
    })
  );
}

apiIdpSubmissionsDirectSubmissionExtractionUpdatePost.PATH = '/api/idp/submissions-direct/submission-extraction/update';
